import { render, staticRenderFns } from "./CategoryPageLayout.vue?vue&type=template&id=7e6e9920"
import script from "./CategoryPageLayout.vue?vue&type=script&lang=js"
export * from "./CategoryPageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports